<template>
  <v-expand-transition>
    <v-alert
      v-show="visible"
      v-set-test-id="[componentName, testId]"
      border="start"
      variant="tonal"
      :type="type"
      class="mb-6 base-alert"
    >
      <template v-for="(_, name) in slots" #[name]="slotData">
        <slot :name="name" v-bind="getSlotData(slotData)" />
      </template>
      <template v-if="closable" #close>
        <v-btn
          v-set-test-id="[componentName, `${testId}-close`]"
          icon
          variant="tonal"
          color="info"
          @click="onClickToggleVisible"
        >
          <font-awesome-icon :icon="faTimes" size="lg" />
        </v-btn>
      </template>
    </v-alert>
  </v-expand-transition>
</template>

<script lang="ts" setup>
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import type { ActionableComponentProps } from '@/common/components/ActionableComponent';
import { vSetTestId } from '@/common/components/ActionableComponent';
import { useSlots } from 'vue';

const componentName = 'BaseAlert';

type Props = ActionableComponentProps & {
  visible?: boolean;
  closable?: boolean;
  type?: 'error' | 'success' | 'warning' | 'info';
};
const props = withDefaults(defineProps<Props>(), {
  visible: true,
  type: 'info',
});

const slots = useSlots();

// Wrap slotData to already be typed
type SlotData = Record<string, unknown>;
function getSlotData(data: unknown): SlotData {
  return (data ?? {}) as SlotData;
}

export type BaseAlertEmits = { (e: 'update:visible', v: boolean): void };
const emit = defineEmits<BaseAlertEmits>();

const onClickToggleVisible = () => {
  emit('update:visible', !props.visible);
};
</script>

<style type="scss">
.base-alert {
  background-color: rgb(var(--v-theme-background));
}
</style>
